import { Button } from "@shared/src/components/ui/button";
import { Card } from "@shared/src/components/ui/card";

interface AdNotFoundProps {
  onBack: () => void;
}

export function AdNotFound({ onBack }: AdNotFoundProps) {
  return (
    <div className="flex flex-col items-center justify-center w-full min-h-[60vh]">
      <Card variant="secondary" className="w-full max-w-lg p-16">
        <div className="text-center space-y-3 mb-6">
          <h5 className="font-medium text-text-primary text-lg">Advertisement not found</h5>
          <p className="text-text-secondary">
            The advertisement you are trying to view is no longer available. Please adjust your search and try again.
          </p>
        </div>
        <div className="flex justify-center">
          <Button variant="outline" size="cta" onClick={onBack} className="px-6">
            Back
          </Button>
        </div>
      </Card>
    </div>
  );
}
